import { render, staticRenderFns } from "./practiceInfo.vue?vue&type=template&id=116798ab&scoped=true"
import script from "./practiceInfo.vue?vue&type=script&lang=js"
export * from "./practiceInfo.vue?vue&type=script&lang=js"
import style0 from "./practiceInfo.vue?vue&type=style&index=0&id=116798ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116798ab",
  null
  
)

export default component.exports